import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'sesion-liveRED';

  constructor(
    public auth: AuthService, 
    private router: Router
  ) {
    console.log( "El usuario log es =", this.auth.userAutenticado() );
  }

  ngOnInit(): void {
  }

  salir(){
    this.auth.logout();
    this.router.navigateByUrl('/prese');
    console.log( "Login es =", this.auth.userAutenticado() );
  }

}
